<template>
    <SJMMall>
        <div class="pickUpCargoWrap">
            <!-- 顶部导航 -->
            <div class="siteNav">
                <SiteNav :siteNavList="siteNavList"></SiteNav>
            </div>
            <div class="contentBox">
                <!-- 填写提货信息 -->
                <div class="pickupInfo">
                    <div class="pickupInfoTitle">
                        <div>{{$t('message.Ifilling')}}</div>
                        <div v-if="$getCookie('i18n') === 'zhCHS'" class="lastTime">最晚提货时间<span style="margin: 0 5px; font-size: 18px;">{{$moment(Number(pickupDeadLine)).format('YYYY-MM-DD HH:mm')}}</span>以前</div>
                        <div v-else class="lastTime">The latest pick-up time is before <span style="margin: 0 5px; font-size: 18px;">{{$moment(Number(pickupDeadLine)).format('YYYY-MM-DD HH:mm')}}</span></div>
                    </div>
                    <div class="pickupInfoList">
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}">
                            <span>{{$t('message.Iicenseplate')}}</span>
                            <el-input v-model.trim="cargoInfo.licensePlate"
                                      :placeholder="$t('message.Imultiplelicense')"
                                      @blur="emailBlurInspect"></el-input>
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}">
                            <span>{{$t('message.Iconsignee')}}</span>
                            <el-input v-model.trim="cargoInfo.pickupPersonName"></el-input>
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}">
                            <span>{{$t('message.contactWay')}}</span>
                            <el-input v-model.trim="cargoInfo.contact"></el-input>
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}">
                            <div  style="display: flex;flex-direction: center;align-items: flex-end;position: relative">
                                <div style="display: flex;flex-direction: row;align-items: center;">
                                    <span >承运单位</span>
                                    <el-input v-model.trim="cargoInfo.stkgetCompany"></el-input>
                                </div>
                                <div style="color: #f5a623;font-size: 12px;position: absolute;left: 0;top: 30px;">开手工出门证需提供承运单位名称</div>
                            </div>
                            
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}" style="width: 350px;margin-left: 80px;display: flex; align-items: center; position: relative;">
                            <div style="display: flex;flex-direction: row;align-items: center;">
                                <span style="white-space: nowrap">预约提货时间</span>
                                <el-input v-model.trim="cargoInfo.pickupDate"
                                          disabled
                                          readonly
                                          style="width: 130px;"></el-input>
                                <el-select v-model="appointmentPickupTime" 
                                           placeholder="请选择"
                                           style="margin-left: 10px; width: 130px;">
                                    <el-option
                                            v-for="item in appointmentPickupTimeOptions"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                            <div style="color: #f5a623;font-size: 12px;position: absolute;left: -12px;top: 30px">东航危险品可提前一天预约，节约现场提货时间，当天预约无效</div>
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}">
                            <span>{{ $t('message.remark') }}</span>
                            <el-input v-model.trim="cargoInfo.remarks"></el-input>
                        </div>
                        <div :class="{pickupInfoItem: true,enpickupInfoItem1: !$isZh()}"></div>


                    </div>
                    <div class="opeartingBtnBox">
                        <div class="legalProvisions">
                            <el-checkbox v-model="ischecks"
                                         :disabled="pickupInfoType === '1'"
                                         class="checked"></el-checkbox>
                            <span>{{$t('message.IIhaveread')}}<span style="color: #0aa7ee; cursor: pointer;" @click="clause">{{$t('message.Ilegalprovisions')}}</span></span>
                            
                        </div>
                        
                        <div>
                            <router-link
                                    :to="`/personalCenter/operationCenter/cargoQuery/importBusiness/SettleAccounts?orderBillCode=${orderBillCode}`"
                                    replace>
                                <el-tooltip
                                        class="item"
                                        effect="dark"
                                        :content="$t('message.stockedOrSettledNotEdit')"
                                        placement="top"
                                        :disabled="true">
                                    <div style="display: inline-block;">
                                        <el-button slot="reference"
                                                   icon="el-icon-edit"
                                                   style="width: auto; min-width: 120px; margin-right: 20px;"
                                                   class="opeartingBtn">{{$t('message.EditIpickingup')}}</el-button>
                                    </div>
                                </el-tooltip>

                            </router-link>
                            <el-tooltip :disabled="ischecks"
                                        class="item"
                                        effect="dark"
                                        :content="$t('message.agreeProvisionsFirst')"
                                        placement="top">
                                <div style="display: inline-block;">
                                    <el-button type="primary"
                                               class="opeartingBtn"
                                               :disabled="!ischecks"
                                               @click="postImportPickupCreatePickupBillData">{{$t('message.confirm')}}</el-button>
                                </div>
                            </el-tooltip>


                        </div>
                    </div>
                    <!-- 法律条款 看js -->
                    <div id="clause">
                    </div>
                </div>
                <!-- 提货单 -->
                <div  class="pickUpCargoBill">
                    <div class="Logo">
                        <img src="@/assets/img/personalCenter/operationCenter/cargoQuery/importBusiness/pinkLogo.png" alt="">
                    </div>
                    <div class="topContainer">
                        <div class="QRCodeContent">
                            <div class="QRCodeBox">
                                <div>
                                    <!-- `drCode:${drCode}` ${origin}/h5.html#/importBusiness/PickUpBillNew?drCode=${drCode}` -->
                                    <img :src="imgBase64Path" :width="165">
                                </div>
                                <p class="QRCodeTips">
                                    <span>微信扫一扫，前往仓库提货</span>
                                </p>
                            </div>
                            <div v-if="$getCookie('i18n') === 'zhCHS'" class="tips">
                                <span>注：切勿将此图提供给陌生人，如有</span>
                                <span>泄露，后果自负</span>
                            </div>
                            <div v-else class="tips">
                                <span>Note: do not provide this QR code to strangers. If it is leaked, you will bear the consequences</span>                
                            </div>
                        </div>
                        <div class="billInfoContent">
                            <p class="billCodeBox">
                                <span>{{$t('message.mainBillCode')}}：{{drCode}}</span>
                                <span>{{$t('message.minorBillCode1')}}：{{minorBillCode}}</span>
                            </p>
                            <div class="cargoInfo">
                                <p class="infoTitle"><i class="iconfont icon-huowuxinxi"></i>{{$t('message.cargoInfo')}}</p>
                                <div class="infoBox">
                                    <div class="longWidth">
                                        <div class="shortWidth">
                                            <span>{{$t('message.pieces')}}：</span>
                                            <span>{{cargoInfo.pieces}}{{$t('message.item')}}</span>
                                        </div>
                                        <div class="flex1">
                                            <span>{{$t('message.Inaturegoods')}}：</span>
                                            <span>{{cargoInfo.cargoNature}}</span>
                                        </div>
                                    </div>
                                    <div class="longWidth">
                                        <div class="shortWidth">
                                            <span>{{$t('message.weight')}}：</span>
                                            <span>{{cargoInfo.weight}}KG</span>
                                        </div>
                                        <div class="flex1">
                                            <span>{{$t('message.boxStatus')}}：</span>
                                            <span>{{cargoInfo.outerBoxStatus}}</span>
                                        </div>
                                    </div>
                                    <div class="longWidth">
                                        <div class="shortWidth">
                                            <span :class="{enpickupDate: !$isZh()}">{{$t('message.arrivalDate1')}}：</span>
                                            <span>{{cargoInfo.arrivalDate}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pickUpInfo">
                                <div class="infoTop">
                                    <p class="infoTitle"><i class="iconfont icon-huoche1"></i>{{$t('message.pickingInform')}}</p>
                                    <div class="pickUpDateTips">
                                        {{$t('message.iafterexpiration')}}
                                    </div>
                                </div>
                                <div class="infoBox">
                                    <div class="shortWidth">
                                        <span :class="{enpickupDate: !$isZh()}">{{$t('message.pickupDate')}}：</span>
                                        <span :class="{enpickupDate: !$isZh()}">{{cargoInfo.pickupDate}}</span>
                                    </div>
                                    <div class="longWidth">
                                        <span>结算地址：</span>
                                        <span>{{$t('message.ilogistics')}}</span>
                                    </div>
                                    <div class="longWidth">
                                        <span>提货地址：</span>
                                        <span>{{address}}</span>
                                    </div>
                                    <div class="longWidth">
                                        <span>{{$t('message.contactNumber')}}：</span>
                                        <span>61156552*286/289（{{$t('message.icustomer')}}）</span>
                                    </div>
                                    <div class="longWidth wareHouseTel">
                                        <span>{{warehousePhone}}<span v-if="warehousePhone.length === 8" class="hide">*286/289</span>（{{$t('message.iwareh')}}）</span>
                                    </div>
                                    <div class="pickUpTips longWidth">
                                        {{$t('message.noteCustomerService')}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>            
                <SJMLoading v-if="pageLoading"></SJMLoading>
            </div>
        </div>
    </SJMMall>
</template>

<script>
    export default {
        name: 'PickUpCargo',// 提货
        data() {
            return {
                // 站点面包屑列表
                siteNavList: [
                    {
                        name: this.$t('message.importBusiness'),
                        link: '/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin',
                        bigData: this.$bigData('importManagement','进口管理','进口管理')
                    },
                    {
                        name: this.$t('message.ITIHUObill'),
                    },
                ],
                origin: window.location.origin,
                orderBillCode: this.$route.query.orderBillCode,// 托单号
                pageLoading: false,// pageLoading
                
                // 提货信息
                pickupInfoType: '',// 提货信息确认标志 0-N、1-Y
                pickupDeadLine: '',// 最晚提货时间（时间戳）
                warehousePhone: '',// 仓库电话

                // 提货单信息
                drCode: '',// 主提单号
                minorBillCode: '',// 分提单号
                // 货物信息
                cargoInfo: {
                    pieces: '',// 件数
                    weight: '',// 重量
                    arrivalDate: '',// 到港日期
                    cargoNature: '',// 货物性质
                    outerBoxStatus: '',// 外箱情况
                    pickupDate: '',// 提货日期
                    pickupPersonName: '',// 提货人姓名
                    contact: '',// 提货人联系方式
                    licensePlate: '',// 车牌号
                    remarks: '',// 备注
                    stkgetCompany: ''// 承运单位
                },
                address: '',// 提货地址
                appointmentPickupTime: '',// 预约提货时间
                ischecks: false,// 法律条款 
                // 历史提货联系人
                pickupContactList: [{
                    id: '',// id
                    licensePlate: '',// 车牌号
                    pickupPersonName: '',// 提货人姓名
                    contact: '',// 提货人联系方式 
                }],

                pickupModifyType: '0',// 提货日期修改标志 0-N、1-Y

                imgBase64Path: '',// 小程序二维码路径
                appointmentPickupTimeOptions: [
                    {value: '', label: ''},
                    {value: '08:00 ~ 10:00', label: '08:00 ~ 10:00'},
                    {value: '10:00 ~ 12:00', label: '10:00 ~ 12:00'},
                    {value: '12:00 ~ 14:00', label: '12:00 ~ 14:00'},
                    {value: '14:00 ~ 16:00', label: '14:00 ~ 16:00'},
                    {value: '16:00 ~ 18:00', label: '16:00 ~ 18:00'},
                    {value: '18:00 ~ 20:00', label: '18:00 ~ 20:00'},
                    {value: '20:00 ~ 22:00', label: '20:00 ~ 22:00'},
                    {value: '22:00 ~ 24:00', label: '22:00 ~ 24:00'},
                    {value: '00:00 ~ 02:00', label: '00:00 ~ 02:00'},
                    {value: '02:00 ~ 04:00', label: '02:00 ~ 04:00'},
                    {value: '04:00 ~ 06:00', label: '04:00 ~ 06:00'},
                    {value: '06:00 ~ 08:00', label: '06:00 ~ 08:00'},
                ],
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() + 1;
                    },
                }

            };
        },
        created() {
            if (!this.orderBillCode) {
                this.$Alert({
                    msg: this.$t('message.illegalAccess'),
                    callback: () => {
                        this.$router.replace('/personalCenter/operationCenter/cargoQuery/importBusiness/ActivationCodeLogin');
                    }
                });
                return;
            }

            // 获取进口提货信息的数据
            this.getImportPickupPickupBillData();

            // 获取进口小程序提货单二维码的数据
            this.getMiniProgramPickupBillQrCodeData();
        },
        methods: {
            emailBlurInspect() {
                this.pickupContactList.forEach(i => {
                    if (this.cargoInfo.licensePlate === i.licensePlate) {
                        this.cargoInfo.pickupPersonName = i.pickupPersonName;
                        this.cargoInfo.contact = i.contact;
                    }
                });
            },
            // 法律条款
            clause() {
                let text = this.$t('message.a1wqal');
                document.getElementById('clause').innerHTML = text;
            },
            // 获取进口提货-提货单的数据
            getImportPickupPickupBillData() {
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/FeeHandler.ashx',
                    data: {
                        act: 'getImportPickupPickupBillData',// 获取进口提货-提货单的数据
                        orderBillCode: this.orderBillCode,// 托单号
                    },
                    beforeSend: () => {
                        this.pageLoading = true;
                    },
                    success: (res) => {
                        this.pickupInfoType = res.success.pickupInfoType;// 提货信息确认标志 0-N、1-Y
                        this.pickupDeadLine = res.success.pickupDeadLine;// 最晚提货时间（时间戳）
                        this.warehousePhone = res.success.warehousePhone;// 仓库电话
                        this.drCode = res.success.drCode;// 主提单号
                        this.minorBillCode = res.success.minorBillCode;// 分提单号
                        this.cargoInfo = res.success.cargoInfo;// 货物信息
                        this.pickupContactList = res.success.pickupContactList;// 历史提货联系人
                        this.address = res.success.address;// 提货地址
                        this.pageLoading = false;
                        // 做过确认 默认勾选法律条款
                        if (this.pickupInfoType === '1') {
                            this.ischecks = true;
                        } else {
                            this.ischecks = false;
                        }
  
                        if (res.success.cargoInfo.bookingTime !== '') {
                            let bookingTime = res.success.cargoInfo.bookingTime;
                            if (bookingTime.indexOf('|') !== -1) {
                                this.appointmentPickupTime = bookingTime.split('|')[1];
                            } else {
                                this.appointmentPickupTime = bookingTime;
                            }
                        }

                        this.pickupModifyType = res.success.pickupModifyType;// 提货日期修改标志 0-N、1-Y
                    }
                });
            },
            // 提交进口提货信息的数据V2
            postImportPickupInfoDataV2() {
                this.$bigData('进口提货单-提货信息确认', '进口提货单-提货信息确认', this.orderBillCode);
                let bookingTime = '';
                if ((this.appointmentPickupTime !== null && this.appointmentPickupTime !== '')) {
                    bookingTime = this.cargoInfo.pickupDate + '|' + this.appointmentPickupTime;
                }                               
    
                this.$ajax({
                    url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportOrderFeeHandler.ashx',
                    data: {
                        act: 'postImportPickupInfoDataV2',// 提交进口提货信息的数据V2
                        orderBillCode: this.orderBillCode,// 托单号
                        name: this.cargoInfo.pickupPersonName,// 提货人姓名
                        contact: this.cargoInfo.contact,// 联系方式
                        licensePlate: this.cargoInfo.licensePlate,// 车牌号
                        remarks: this.cargoInfo.remarks,// 备注
                        bookingTime: bookingTime,
                        stkgetCompany: this.cargoInfo.stkgetCompany
                    },
                    beforeSend: () => {
                        this.pageLoading = true;
                    },
                    success: () => {
                        this.$ajax({
                            url: '/personalCenterHandler/operationCenter/cargoQuery/ImportBusiness/unmanned/ImportOrderFeeHandler.ashx',
                            data: {
                                act: 'postImportPickupCreatePickupBillData',// 提交进口提货生成提货单的数据
                                orderBillCode: this.orderBillCode,// 托单号
                            },
                            success: () => {
                                // 提交进口提货信息的数据V2
                                this.$Message({
                                    type: 'success',
                                    msg: this.$t('message.a2dsaf')
                                });
                                // 获取进口提货信息的数据
                                this.getImportPickupPickupBillData();
                            },
                        });
                        
                    },
                    complete: () => {
                        this.pageLoading = false;
                    }
                });
            },
            // 提交进口提货生成提货单的数据
            postImportPickupCreatePickupBillData() {
                // if (this.cargoInfo.licensePlate === '') {
                //     this.$Message({msg: '请输入提货车牌号'});
                //     return;
                // } else if (this.cargoInfo.pickupPersonName === '') {
                //     this.$Message({msg: '请输入提货人姓名'});
                //     return;
                // } else if (this.cargoInfo.contact === '') {
                //     this.$Message({msg: '请输入提货电话'});
                //     return;
                // } 
                this.postImportPickupInfoDataV2();
                
            },

            // 获取进口小程序提货单二维码的数据
            getMiniProgramPickupBillQrCodeData() {
                this.$ajax({
                    url: '/MiniProgramHandler/ImportBusiness/MiniPickupHandler.ashx',
                    data: {
                        act: 'getMiniProgramPickupBillQrCodeData',// 获取进口小程序提货单二维码的数据
                        orderBillCode: this.orderBillCode
                    },
                    success: (res) => {
                        this.imgBase64Path = res.success.imageBase64;
                    }
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .pickUpCargoWrap {
        position: relative;
        min-width: 1245px;
        overflow: hidden;
        background-color: #f3f3f4;

        /* 顶部 网站导航 */
        .siteNav {
            width: 1245px;
            margin: 0 auto;
        }

        /* 内容 */
        .contentBox {
            position: relative;
            width: 1245px;
            min-height: 900px;
            margin: 0 auto 155px;

            .pickupInfo {
                position: relative;
                box-sizing: border-box;
                padding: 30px 50px;
                margin: 0 auto 15px;
                background-color: #fff;

                .pickupInfoTitle {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 25px;
                    font-size: 18px;

                    .lastTime {
                        font-size: 18px;
                        color: #e73c2d;
                    }
                }

                .pickupInfoList {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;

                    .pickupInfoItem {
                        position: relative;
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        width: 290px;
                        margin-bottom: 20px;

                        .redPoint {
                            color: red;
                        }

                        .el-input {
                            width: 200px;
                            margin-left: 8px;

                            /deep/ .el-input__inner {
                                border-radius: 0;
                            }
                        }
                    }

                    .enpickupInfoItem1 {
                        width: 380px;
                    }
                }

                .opeartingBtnBox {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .legalProvisions {
                        display: flex;
                        align-items: center;

                        .checked {
                            margin-right: 8px;
                        }
                    }

                    .opeartingBtn {
                        width: 120px;
                        height: 44px;
                        font-size: 20px;
                    }
                }
            }
        }
    }

    .pickUpCargoBill {
        padding: 40px 87.5px;
        background-color: white;

        .Logo {
            margin-bottom: 17px;
            text-align: center;
        }

        .topContainer {
            display: flex;
            width: 1070px;
            margin-bottom: 20px;

            .QRCodeContent {
                width: 260px;
                color: white;
                background-color: #1b91d0;

                .QRCodeBox {
                    margin-top: 70px;

                    > div {
                        width: 165px;
                        height: 165px;
                        margin: 0 auto;
                    }

                    .QRCodeTips {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: 200px;
                        margin: 20px auto;
                        font-size: 13px;
                        opacity: 0.75;
                    }
                }

                .tips {
                    display: flex;
                    flex-direction: column;
                    padding-left: 14px;
                    margin-top: 150px;
                    font-size: 14px;
                    opacity: 0.7;
                }
            }

            .billInfoContent {
                box-sizing: border-box;
                width: 810px;
                padding: 27px 30px 37px;
                background-color: #edf9ff;

                .billCodeBox {
                    padding-bottom: 6px;
                    font-size: 16px;

                    span {
                        margin-right: 46px;
                        color: #181818;
                    }
                }

                .cargoInfo,
                .payInfo,
                .pickUpInfo {
                    width: 100%;
                    margin-top: 14px;
                    overflow: hidden;
                    font-size: 16px;
                    background-color: white;
                    border-radius: 4px;

                    .infoTop {
                        display: flex;
                        align-items: center;
                        border-bottom: 1px solid rgba(220, 223, 230, 0.5);
                    }

                    .pickUpDateTips {
                        margin-left: 10px;
                        font-size: 14px;
                        color: #f5a623;
                    }

                    .infoTitle {
                        box-sizing: border-box;
                        display: flex;
                        align-items: center;
                        height: 43px;
                        padding-left: 24px;
                        font-size: 18px;
                        border-bottom: 1px solid rgba(220, 223, 230, 0.5);

                        .iconfont {
                            margin: 5px 12px 0 0;
                            font-size: 22px;
                        }
                    }

                    .infoBox {
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: wrap;
                        padding-left: 24px;
                        margin-top: 6px;
                        font-size: 16px;
                        color: #999;

                        > div {
                            margin-bottom: 13px;
                        }

                        .shortWidth {
                            width: 360px;

                            > span:nth-child(1) {
                                display: inline-block;
                                width: 80px;
                            }

                            > span.enpickupDate {
                                width: 124px;
                            }
                        }

                        .flex1 {
                            flex: 1;
                        }

                        .longWidth {
                            display: flex;
                            width: 100%;

                            > span.enpickupDate {
                                width: 114px;
                            }
                        }

                        .blue {
                            color: #1b91d0;
                        }

                        .red {
                            color: #f01a34;
                        }

                        .payTips {
                            margin-top: -8px;
                            margin-bottom: 14px;
                            font-size: 13px;
                            color: #f5a623;
                        }

                        .pickUpTips {
                            margin-top: -8px;
                            font-size: 14px;
                            color: #aaa;
                        }

                        .wareHouseTel {
                            padding-left: 80px;

                            .hide {
                                visibility: hidden;
                            }
                        }
                    }
                }
            }
        }
    }
</style>